import { Result, ISingleTransactionRequest } from "../models/interfaces";
import { BaseService } from "./BaseService";

export type Withdrawal = {
  id?: number;
  accountId?: number;
  narration?: number;
  amount?: number;
  accountNo?: string;
  accountName?: string;
  transactionStatus?: number;
};

export class WithdrawalService extends BaseService {
  private wdApi = "withdrawals";

  async getWithdrawals(params: {
    accountId?: number;
    narration?: string;
    fromDate?: Date;
    toDate?: Date;
    pageIndex?: number;
    recordCount?: number;
  }): Promise<Result<Withdrawal[]> | undefined> {
    return this.get(`withdrawals`, params);
  }

  async getWithdrawal(id: number): Promise<Result<Withdrawal> | null> {
    return this.get(this.wdApi + "/" + id);
  }

  async bookOrUpdateWithdrawal(
    params: ISingleTransactionRequest,
    withdrawalId?: number
  ): Promise<Result<Withdrawal> | null> {
    if (withdrawalId) {
      return this.post(`${this.wdApi}`, params);
    } else {
      return this.put(`${this.wdApi}/${withdrawalId}`, params);
    }
  }

  async deleteWithdrawal(params: number): Promise<Result<boolean> | null> {
    return this.delete(`${this.wdApi}/${params}`);
  }

  async postWithdrawal(id: number): Promise<any> {
    return this.post(`${this.wdApi}/${id}/approve`);
  }

  async reverseWithdrawal(id: number): Promise<any> {
    return this.post(`${this.wdApi}/${id}/reverse`);
  }
}

export default new WithdrawalService();
